import React from 'react';
import './vs.scss'

// Home Page
// see the wireframe

function vs() {
  return (
  <div className="div">
  </div>
  )
}

export default vs;